import get from 'lodash.get';

const getBusinessCategory = (rootState) =>
  get(rootState, 'ws.site.meta.settings.businessCategory', null);

export default getBusinessCategory;
